import { z } from 'zod/v4-mini';

import { Schema } from '@/utils/zodUtils.ts';

export type FileModel = {
  url: string;
  name: string;
  path: string;
};

export const fileSchema: Schema<FileModel> = z.object({
  url: z.string(),
  name: z.string(),
  path: z.string(),
});

export type FileToUpload = {
  file?: Blob;
  name: string;
};

export type UploadedFileType = 'description' | 'prescriptions' | 'messages';

export type UploadFileModel = {
  file: File;
  type: UploadedFileType;
  patient_firstname: string;
  patient_lastname: string;
};
